import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — the live route is /therapists. Redirect so external links and
// older nav references don't 404.
export const Route = createFileRoute("/therapist-directory")({
  beforeLoad: () => {
    throw redirect({ to: "/therapists" });
  },
});
